export const API_SERVER = 'http://test.emilabs.io:4000/api/v1';
export const COGNITO_LOGIN_URL = 'https://login-staging.emilabs.io';
export const METRICS_METABASE_SITE_URL = 'https://metabase.emilabs.ai';
export const PRODUCT_FRUITS_WORKSPACE_CODE = '';
export const SENTRY_DSN = '';
export const TRACKING_ENABLED = false;
export const OTEL_COLLECTOR_API = '';